import React, { useEffect, useState } from "react";
import { ArrowUpLeft, GraduationCap, ShieldCheck } from "lucide-react";
import Logo from "../../assets/img/NewsImgs/logo192.png";
import SignInImage from "../../assets/img/auth/sign-in-journey.png";
import SignUpImage from "../../assets/img/auth/sign-up-community.png";
import "./AuthLayout.css";
import { useLanguage } from "../../i18n/LanguageContext";
import { siteUrl } from "../../config/urls";

const content = {
    signIn: {
        image: SignInImage,
        eyebrow: "مکاتبهٔ تحصیلی شما",
        title: "ارتباط مؤثر، از انتخاب استاد مرتبط شروع می‌شود.",
        text: "انتخاب استاد، ایمیل اختصاصی، بازبینی و Follow-up را در یک فضای منظم مدیریت کنید.",
        stat: "۱۰۰٪",
        statLabel: "بازبینی ایمیل پیش از ارسال",
        icon: GraduationCap,
        alt: "برنامه‌ریزی برای مکاتبه با استادهای دانشگاه",
    },
    signUp: {
        image: SignUpImage,
        eyebrow: "آینده بدون مرز",
        title: "مسیر تازه‌ات را با آدم‌های درست بساز.",
        text: "به جامعه‌ای از متقاضیان بین‌المللی بپیوندید و قدم‌های بعدی را شفاف‌تر بردارید.",
        stat: "۵۰+",
        statLabel: "کشور در شبکه فرصت‌های ما",
        icon: GraduationCap,
        alt: "همکاری دانشجویان بین‌المللی برای اپلای",
    },
};

const AuthLayout = ({ mode = "signIn", children }) => {
    const [ready, setReady] = useState(false);
    const { isEnglish, direction, toggleLanguage } = useLanguage();
    const englishContent = mode === "signIn" ? { eyebrow: "Your academic outreach", title: "Effective outreach starts with a relevant professor.", text: "Manage professor selection, tailored emails, review, and follow-up in one workspace.", stat: "100%", statLabel: "reviewed before sending", alt: "Planning professor outreach" } : { eyebrow: "A focused academic path", title: "Build your next step with the right professors.", text: "Join research applicants and manage academic outreach with greater clarity.", stat: "50+", statLabel: "destinations in our academic network", alt: "Research applicants preparing academic outreach" };
    const item = isEnglish ? { ...content[mode], ...englishContent } : content[mode];
    const FeatureIcon = item.icon;

    useEffect(() => {
        const frame = requestAnimationFrame(() => setReady(true));
        return () => cancelAnimationFrame(frame);
    }, []);

    return (
        <main className="auth-page" dir={direction}>
            <div className={`auth-card auth-card--${mode} ${ready ? "auth-card--ready" : ""}`}>
                <section className="auth-visual" aria-label={isEnglish ? "About Infinity Apply" : "درباره اینفینیتی اپلای"}>
                    <img className="auth-visual__image" src={item.image} alt={item.alt} />
                    <div className="auth-visual__shade" />

                    <a className="auth-brand" href={siteUrl("/")} aria-label={isEnglish ? "Back to Infinity Apply" : "بازگشت به اینفینیتی اپلای"}>
                        <span className="auth-brand__logo"><img src={Logo} alt="" /></span>
                        <span><strong>Infinity Apply</strong><small>{isEnglish ? "Academic Outreach" : "مکاتبهٔ تحصیلی"}</small></span>
                    </a>

                    <div className="auth-story">
                        <span className="auth-story__eyebrow"><FeatureIcon size={16} />{item.eyebrow}</span>
                        <h2>{item.title}</h2>
                        <p>{item.text}</p>
                    </div>

                    <div className="auth-proof">
                        <div><strong>{item.stat}</strong><span>{item.statLabel}</span></div>
                        <span className="auth-proof__icon"><ArrowUpLeft size={21} /></span>
                    </div>
                    <div className="auth-secure"><ShieldCheck size={15} /> {isEnglish ? "Your information remains secure and confidential" : "اطلاعات شما امن و محرمانه می‌ماند"}</div>
                </section>

                <section className="auth-form-panel">
                    <button className="auth-language-toggle" type="button" onClick={toggleLanguage}>{isEnglish ? "FA" : "EN"}</button>
                    <a className="auth-mobile-brand" href={siteUrl("/")}>
                        <img src={Logo} alt="Infinity Apply" />
                        <span><strong>Infinity Apply</strong><small>{isEnglish ? "Academic Outreach" : "مکاتبهٔ تحصیلی"}</small></span>
                    </a>
                    {children}
                </section>
            </div>
        </main>
    );
};

export default AuthLayout;
